export enum EModeDesinfection {

    Aucune = 1,
    Flambage,
    Lingette,
    Alcool,
}